module.exports = __webpack_public_path__ + "img/1.629cc3af.jpg";